import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { addTransportationVehicle, editTransportationVehicle } from 'features/transportation/transportationSlice'
import { transportationVehicleTypes } from './transportationData'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'

export const TransportationVehicleModal = ({ closeModal, value }: { closeModal: any, value?: ITransportationVehicleModal }) => {
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)
    const [state, setState] = useState<ITransportationVehicleModal>(value || {
        machine: null,
        vehicleType: null
    })

    const handleSave = async () => {
        const resp = await dispatch(value?.id ? editTransportationVehicle(state) : addTransportationVehicle(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }


    const handleSelect = (value: ISelectValue, name: string) => {
        setState(prev => ({ ...prev, [name]: value }))
    }


    const parse = (data: any) => {
        return data.data.map((item) => ({ label: item.name, value: item.id }))
    }

    return <Modal black>
        <Flex column between center>
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Transportation Vehicle</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <HonestSelectAsyncInput name='machine' labelText='Machine' link='machines' placeholder='Select a machine' onChange={handleSelect} parserFunction={parse} defaultValue={state.machine?.label} nomarg />
                <HonestSelectInput options={transportationVehicleTypes} labelText='Type' name='vehicleType' onChange={handleSelect} defaultValue={state.vehicleType?.value} />
            </Flex>
            <Button disabled={!state.machine?.value || !state.vehicleType?.value} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface ITransportationVehicleModal {
    id?: number
    machine: ISelectValue
    vehicleType: ISelectValue
}